/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/18
 */
import './index.css';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import omit from 'omit.js';
import classNames from 'classname';
import Loading from '../../../svgs/loading';

class Button extends Component {
  static propTypes = {
    size: PropTypes.oneOf(['large', 'small', 'max']),
    type: PropTypes.oneOf(['primary', 'dashed', 'danger', 'disabled']),
    onClick: PropTypes.func,
    shape: PropTypes.oneOf(['cycle']),
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
      delay: PropTypes.number,
    })]),
    htmlType: PropTypes.oneOf(['button', 'submit']),
    className: PropTypes.string,
    children: PropTypes.any
  };
  static defaultProps = {
    type: 'primary'
  };
  constructor (props) {
    super(props);
    this.prefixCls = 'store-btn';
    this.state = {
      clicked: false,
      loading: this.props.loading
    }
  }
  componentWillReceiveProps (nextProps) {
    const currentLoading = this.props.loading;
    const loading = nextProps.loading;

    if (currentLoading) {
      clearTimeout(this.delayTimeout);
    }

    if (typeof loading !== 'boolean' && loading && loading.delay) {
      this.delayTimeout = setTimeout(() => this.setState({ loading }), loading.delay);
    } else {
      this.setState({ loading });
    }
  }
  handleClick (e) {
    // Add click effect
    this.setState({ clicked: true });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.setState({ clicked: false }), 500);

    const onClick = this.props.onClick;
    if (onClick) {
      onClick(e);
    }
  }
  componentWillUnmount () {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
  render () {
    const {
      type, htmlType, shape, size = '',
      className, children, ...others
    } = this.props;

    const { loading, clicked } = this.state;

    let sizeCls = '';
    switch (size) {
      case 'large':
        sizeCls = 'lg';
        break;
      case 'small':
        sizeCls = 'sm';
        break;
      case 'max':
        sizeCls = 'max';
        break;
      default:
        break;
    }
    const classes = classNames(this.prefixCls, className, {
      [`${this.prefixCls}-${type}`]: type,
      [`${this.prefixCls}-${shape}`]: shape,
      [`${this.prefixCls}-${sizeCls}`]: sizeCls,
      [`${this.prefixCls}-loading`]: loading,
      [`${this.prefixCls}-clicked`]: clicked
    });
    return <button
      {...omit(others, ['loading', 'clicked'])}
      type={htmlType || 'button'}
      className={classes}
      onClick={this.handleClick.bind(this)}>
      {loading ? <Loading/> : ''}{children}
    </button>
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/lib/button/index.js